
import { Controller } from "stimulus"
import { Calendar } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import interactionPlugin from '@fullcalendar/interaction';
import bootstrapPlugin from '@fullcalendar/bootstrap';
import momentTimezonePlugin from '@fullcalendar/moment-timezone';

export default class extends Controller {

  setupCalendar(){
    let account_id = document.getElementById('javascript_variables').dataset.accountId;
    let timezone = document.getElementById('javascript_variables').dataset.timezone;
    let calendarEl = document.getElementById('calendar');
    let mobile = (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent));
    let center = 'title';
    let right = 'dayGridMonth,timeGridWeek,timeGridDay,listWeek';
    if (mobile) {
      center = false;
      right = false;

    };
    let calendar = new Calendar(calendarEl, {
      listDaySideFormat: {
        month: 'long',
        year: 'numeric',
        day: 'numeric',
      },
      listDayFormat: {
        weekday: 'long'
      },
      timeZone: timezone,
      aspectRatio: 2,
      contentHeight: 'auto',
      noEventsContent: '',
      lazyFetching: true,
      plugins: [ dayGridPlugin, timeGridPlugin, listPlugin, interactionPlugin, bootstrapPlugin, momentTimezonePlugin ],
      themeSystem: 'flatly',
      headerToolbar: {
        left: "today prev,next",
        center: center,
        right: right,
      },
      navLinks: true,
      buttonText: {
        dayGridMonth: 'Month',
        timeGridWeek: 'Week',
        timeGridDay: 'Day',
        listWeek: 'List',
        today: "Today"
      },
      initialView: 'listWeek',
      displayEventTime: true,
      displayEventEnd: !mobile,
      dayHeaders: true,
      eventColor: '#6B9CD6',
      eventTextColor: '#ffffff',
      themeSystem: 'bootstrap',
      events: 'scheduled/get_events.json',
      eventDidMount: function(info) {
        var graphicEl = info.el.querySelector('.fc-list-event-graphic');
        if (graphicEl && info.event.extendedProps.type == "video") {
          graphicEl.innerHTML = '<span class="text-primary"><i class="fas fa-video"></i><span>';
        }else if (graphicEl){
          graphicEl.innerHTML = '<span class="text-primary"><i class="fas fa-phone"></i><span>';
        }
      },
      eventContent: function( arg ) {
        return { html: `<a data-turbolinks="false" href='/accounts/${account_id}/scheduled/${arg.event.id}'>${arg.event.title}</a>` };
      },
      loading: function (isLoading, view) {
        if (!isLoading) {
          let element = document.getElementsByClassName('fc-list-empty-cushion')[0];
          if (element) {
            element.innerHTML = 'No sessions to show';
          }
        }
      }
    });
    calendar.render();
  }


  initialize() {
    this.setupCalendar();
  }


}
